import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const verificationURL = window.origin + "/payment-status";

/**
 * A page that shows a credit card form to enable the user to pay by their credit card.
 *
 * @returns {JSX.Element}
 */

const PaymentConfirmation = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { t, i18n: { language } } = useTranslation("global");
  useEffect(() => {
    if (!state || !state.bookingData || !state.checkoutId) {
      navigate("/", { replace: true });
      return;
    }
    const checkoutId = state.checkoutId;
    const bookingData = { ...state.bookingData, checkoutId };
    sessionStorage.setItem("bookingData", JSON.stringify(bookingData));
    if (checkoutId) {
      const paymentWidgetScript = document.createElement("script");
      paymentWidgetScript.src = `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}?checkoutId=${checkoutId}` 
      paymentWidgetScript.integrity = state.integrity;
      paymentWidgetScript.crossOrigin = "anonymous";
      paymentWidgetScript.async = true;
      document.body.appendChild(paymentWidgetScript);

      const wpwlOptionsScript = document.createElement("script");
      wpwlOptionsScript.type = "text/javascript";
      const styleOptions =
        language === "en" ? "'text-align': 'start'" : "'text-align': 'end'";

      wpwlOptionsScript.innerHTML = `
              var wpwlOptions = {
               iframeStyles: {
                'card-number-placeholder': {
                    ${styleOptions}
                }} ,
                paymentTarget: "_top",
                locale: '${language}',
                onSuccess: function() {
                  window.location.href = '${verificationURL}';
                },
                onFail: function() {
                  window.location.href = '${verificationURL}';
                },
                applePay: {
                  merchantIdentifier: "merchant.amk.llc",
                  merchantCapabilities: ["supports3DS"],
                  supportedNetworks: ["visa", "masterCard"],
                  countryCode: "SA", 
                  currencyCode: "SAR", 
                  entityType: "MERCHANT" 
                }
              };
            `;
      document.body.appendChild(wpwlOptionsScript);
      return () => {
        document.body.removeChild(paymentWidgetScript);
        document.body.removeChild(wpwlOptionsScript);
      };
    }
  }, [state]);

  if (!state || !state.bookingData) {
    return <></>;
  }

  const paymentMethodName = state.bookingData.payment_method;
  const price = state.bookingData.price;

  // Extract the nested ternary operation
  const paymentMethodMap = {
    "Mada": "MADA",
    "Credit Card": "VISA MASTER",
    "Apple Pay": "APPLEPAY"
  };

  // Fallback to empty string if not found
  const selectedBrand = paymentMethodMap[paymentMethodName] || "";
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div>
        <div className="flex justify-between">
          <p className="mb-3 font-bold text-background_steel_blue">
            {t("hero.price_text")}: {price} {t("hero.sar_text")}
          </p>
        </div>
        <form
          action={verificationURL}
          className="paymentWidgets"
          data-brands={selectedBrand} // Use the extracted value here
        />
      </div>
    </div>
  );
};

export default PaymentConfirmation;
